// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Recomended_wrapper__Ci8kN","title":"Recomended_title__16L8H","list":"Recomended_list__e1_zV","cardFooter":"Recomended_cardFooter__88_BR"};